// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3-pX2","title":"ClientInsurance_title__OS_JI","itemText":"ClientInsurance_itemText__3vZaj"};